import { Component, EventEmitter, Input, OnInit, Output, computed, signal, inject, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LorenSidenavTourSteps } from "../../../../../../constants/loren-tour-steps.constants";
import { Language } from "../../../../../../enums/language.enum";
import { LorenUtilsService } from "../../../../../../services/loren-utils-service/loren-utils.service";

@Component({
    selector: "loren-language-switcher",
    templateUrl: "./loren-language-switcher.component.html",
    styleUrls: ["./loren-language-switcher.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenLanguageSwitcherComponent implements OnInit {
  private translate = inject(TranslocoService);

  @Input() isHandset: boolean;
  @Output() changeLanguage = new EventEmitter<string>();

  readonly language = Language;
  readonly languageAnchorId = LorenSidenavTourSteps.find(
    (x) => x.anchorId === "language"
  ).anchorId;

  currentLanguage = signal<string>(null);

  newLanguage = computed<Language>(() =>
    this.currentLanguage().toLowerCase() === Language.BG
      ? Language.EN
      : Language.BG
  );

  ngOnInit() {
    this.currentLanguage.set(this.translate.getDefaultLang().toUpperCase());
  }

  selectLanguage(lang: string) {
    LorenUtilsService.updateLastSelectedLanguage(lang);
    location.reload();
  }
}
